import { Loader, Modal, TextArea } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { useStores } from 'index';
import { useLookupInstructorEmails } from 'queryHooks/Admin/Organization/useLookupInstructorEmails';
import { useState } from 'react';
import { AdminOrganizationInstructor } from 'types/admin/organizations';

export const InviteInstructorsModal = ({
  isOpen,
  instructors,
  setInstructors,
  onClose,
}: {
  isOpen: boolean;
  instructors: AdminOrganizationInstructor[];
  setInstructors: (instructors: AdminOrganizationInstructor[]) => void;
  onClose: () => void;
}) => {
  const notificationsStore = useStores().notificationStore;
  const [inputEmails, setInputEmails] = useState<string>('');
  const [emailsToCheck, setEmailsToCheck] = useState<string[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const lookupEmailsAndAddInstructors = () => {
    setErrorMessage('');
    const emailsToCheck = inputEmails
      .split('\n')
      .filter((inputEmail) => !instructors.some((instructor) => instructor.email === inputEmail.trim()));

    setInputEmails(emailsToCheck.join('\n'));
    setEmailsToCheck(emailsToCheck);

    if (emailsToCheck.length > 0) {
      checkInstructorEmails.mutate();
    } else {
      setErrorMessage('The email(s) you entered are already in the list');
    }
  };

  const checkInstructorEmails = useLookupInstructorEmails(emailsToCheck, {
    onSuccess: (response) => {
      const notFoundInstructors = emailsToCheck.filter((email) => !response.find((el) => el.email === email));

      if (!notFoundInstructors.length) {
        setInstructors([...instructors, ...response]);
        notificationsStore.addToast('success', 'Instructors invited successfully', 'success');
        onClose();
        setErrorMessage('');
      } else {
        setErrorMessage(`The following email(s) are not registered: ${notFoundInstructors.join(', ')}`);
      }
      setInputEmails('');
      setEmailsToCheck([]);
    },
    onError: () => notificationsStore.addToast('error', `There was an internal error while inviting instructors.`, 'error'),
  });

  return (
    <Modal
      cancelBtn={{
        label: 'Cancel',
        onClick: () => onClose(),
      }}
      confirmBtn={{
        label: 'Add',
        onClick: () => lookupEmailsAndAddInstructors(),
        disabled: errorMessage !== '',
      }}
      open={isOpen}
      onClose={() => onClose()}
      title='Invite instructors'
      titleIcon={null}
    >
      <div className='modal-body tmu-table-wrapper admin-edit-section'>
        {checkInstructorEmails.isPending ? (
          <div className='loader-wrapper' style={{ zIndex: 10 }}>
            <Loader size='large' />
          </div>
        ) : (
          <></>
        )}
        <h2>Invite instructors by email</h2>
        <div className='inputs-container'>
          <Paragraph>
            <>
              To be eligible for an invitation, the invitee must have a (free) TMU account. Sign-ups are done at TrackamanUniversity.com.
              Click{' '}
              <a href='https://login.trackmangolf.com/Account/Register' title='Go to sign up page' target='_blank' rel='noreferrer'>
                here
              </a>{' '}
              to sign up an instructor.
            </>
          </Paragraph>
          {errorMessage !== '' ? (
            <Paragraph>
              <>{errorMessage}</>
            </Paragraph>
          ) : (
            <></>
          )}
          <TextArea
            label={'Emails'}
            value={inputEmails}
            onChange={(e) => {
              setErrorMessage('');
              setInputEmails(e.target.value.replace(/,|\s+/g, '\n'));
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
